import { DesignElement } from "@design-controls/types";
import { useMutation } from "react-query";
import { designControlsApi } from "../../api/designControls";
import { useCurrentUser } from "@qualio/ui-components";
import { useCurrentProduct } from "../useCurrentProduct";

export const useCreateDesignElement = () => {
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();

  return useMutation({
    mutationFn: (data: Partial<DesignElement>) =>
      designControlsApi.createDesignElement(companyId, productId, data),
  });
};
